import React from 'react';

export default function ProfileTemplateIcon(props) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' {...props}>
      <g fill='none' fillRule='evenodd'>
        <g fill='currentColor' fillRule='nonzero'>
          <path d='M19 16c3.836 0 7 2.681 7 6.067 0 .515-.423.933-.944.933H12.944c-.521 0-.944-.418-.944-.933C12 18.68 15.164 16 19 16zm0-8c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zm-7.942 1.868c1.069 1.069 1.15 2.75.245 3.913l1.589 1.587c.144.144.144.379 0 .524-.145.144-.38.144-.524 0l-1.587-1.589c-1.162.906-2.844.824-3.913-.245-1.157-1.157-1.157-3.033 0-4.19 1.157-1.157 3.033-1.157 4.19 0zm-3.472.718c-.781.78-.781 2.047 0 2.828.694.694 1.784.777 2.57.218l.269-.207.155-.198c.598-.768.553-1.86-.104-2.577l-.062-.064c-.78-.781-2.047-.781-2.828 0z' />
        </g>
      </g>
    </svg>
  );
}
